import {EntityData, EntityModel} from "@fedeltapointofsale/data-client";
import {EmployeeData} from "./employee.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class EmployeeEntityModel extends EntityModel<EmployeeData> {

    constructor(injector: Injector) {
        super(injector, EmployeeData)
    }

    protected override onNewEntity(entityData: EmployeeData): void {
        entityData.user.employed = true;
    }

    protected override onBeforeSaveEntity(entityData: EmployeeData): void {
        entityData.user.firstName = entityData.contact.firstName;
        entityData.user.lastName = entityData.contact.lastName;
    }

    override isEntityCloneable(): boolean {
        return false;
    }
}
